module.exports = require('./lib');
module.exports.connect = require('react-redux').connect;
